import React from "react";

import ListItem from "./ListItem";
import DeliveryDetails from "./DeliveryDetails";
import RestaurantFilters from "./Filter";

//Components
import MetaHeader from "./components/List/MetaHeader";
import DealRestaurantsSlider from "./components/List/DealRestaurantsSlider";
import RestaurantsNotFound from "./components/List/RestaurantsNotFound";
import EnterPostCode from "./EnterPostCode";
import CustomListSlider from "./components/List/CustomListSlider";

const List = ({
  restaurants,
  changeDelivery,
  onCloseSection,
  filterSection,
  handleFilterSection,
  submitFilter,
  routeName,
  flatNumber,
  defaultDistance,
  maxDistance,
  preOrderEnd,
  preOrderStart,
  orderBy,
  postalCode,
  isMobile,
  customList
}) => {
  const handleCloseEnterPostCode = link => {
    if (link.status === "close") {
      window.location.replace("/");
    } else {
      window.location.replace(link);
    }
  };
  let onlyDealRestaurants = [];
  let otherRestaurants = [];
  if (orderBy === "DISTANCE") {
    onlyDealRestaurants = restaurants.filter(
      restaurant =>
        restaurant.deal.reward_percent && !restaurant.restaurantStatusCode
    );

    const removedIndex = (isMobile && 1) || 3;
    const dealArr = (onlyDealRestaurants.slice(0, removedIndex) || []).map(
      res => res.uid
    );

    otherRestaurants = restaurants.filter(
      restaurant => dealArr.indexOf(restaurant.uid) === -1
    );
  }
  const listRestaurants =
    (otherRestaurants.length && otherRestaurants) || restaurants;

  return (
    <React.Fragment>
      <MetaHeader routeName={routeName} flatNumber={flatNumber} />

      {(onlyDealRestaurants && onlyDealRestaurants.length && (
        <DealRestaurantsSlider
          isMobile={isMobile}
          onlyDealRestaurants={onlyDealRestaurants}
        />
      )) || <noscript />}
      {(customList &&
        customList.length &&
        customList.map((list, index) => (
          <CustomListSlider key={index} isMobile={isMobile} list={list} />
        ))) || <noscript />}
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12">
            <div className="row">
              {(changeDelivery && (
                <DeliveryDetails
                  route="list"
                  maxDistance={maxDistance}
                  defaultDistance={defaultDistance}
                  preOrderStart={preOrderStart}
                  preOrderEnd={preOrderEnd}
                  onCloseSection={() => onCloseSection("changeDelivery")}
                />
              )) || <noscript />}
              {(filterSection && (
                <RestaurantFilters
                  handleFilterSection={handleFilterSection}
                  onSubmit={submitFilter}
                  onCloseSection={onCloseSection}
                />
              )) || <noscript />}

              {(listRestaurants.length &&
                listRestaurants.map((restaurant, index) => (
                  <ListItem
                    key={restaurant.uid}
                    restaurant={restaurant}
                    index={index}
                  />
                ))) ||
                (postalCode && <RestaurantsNotFound />) || (
                  <EnterPostCode
                    route="list"
                    onClose={handleCloseEnterPostCode}
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default List;
